/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { CloseIcon } from '../../assets/svg/MenuIcons';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { environment } from '@rb-serve-app/core';

interface LockedModalProps {
  isOpen: boolean;
  onClose: () => void;
  showFeatureLocked?: () => void;
  coorpUser?: boolean;
}

const LockedAccount: React.FC<LockedModalProps> = ({
  isOpen,
  onClose,
  showFeatureLocked,
  coorpUser = false,
}) => {
  const { contentfulData } = useSelector(
    (state: { contentful: any | null }) => state.contentful
  );
  const { entries, assets } = contentfulData || {};
  const featureFlaggingData = entries?.rb_feature_flagging?.featureFlagging;
  const signInContentfulldata = entries?.rb_signin;
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);
  const title = coorpUser
    ? signInContentfulldata?.signinIdentityVerification?.corp_user_title
    : signInContentfulldata?.accountLockedPopupTitle;
  const subTitle = coorpUser
    ? signInContentfulldata?.signinIdentityVerification?.corp_user_subtitle
    : signInContentfulldata?.accountLockedPopupSubtitle;
  const navigate = useNavigate();
  const coorpUserLogin = environment.coorpUserLoginUrl;
  const handelCoorpUser = () => {
    const language = localStorage?.getItem('language');
    let params = 'en_CA';
    if (language == 'fr') {
      params = 'fr_CA';
    } else {
      params = 'en_CA';
    }
    window.open(`${coorpUserLogin}&locale=${params}`, '_blank');
    onClose();
    navigate(0);
  };
  if (!isOpen || !signInContentfulldata) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription"
    >
      <div
        id="Locked-Account-Modal"
        className="bg-white p-6 rounded-2xl max-w-xs mx-auto relative w-[290px] h-auto"
        role="document"
      >
        <div className="flex justify-center mb-4 mt-5">
          <img
            src={assets?.account_locked_popup_icon}
            alt="Locked account icon"
            width={80}
            height={80}
          />
        </div>

        <h2 id="modalTitle" className="text-xl font-bold text-center">
          {title}
        </h2>

        <p
          id="modalDescription"
          className="text-sm text-gray-600 text-center mt-2"
        >
          {subTitle}
        </p>

        {coorpUser ? (
          <button
            aria-label={`CTA ${
              signInContentfulldata?.signinIdentityVerification
                ?.corp_user_cta_button
            }`}
            onClick={handelCoorpUser}
            className="text-text16 font-semibold mt-10 py-2 px-4 focus:outline-none w-full bg-red-600 text-white hover:bg-red-700"
          >
            {
              signInContentfulldata?.signinIdentityVerification
                ?.corp_user_cta_button
            }
          </button>
        ) : (
          <button
            aria-label={signInContentfulldata?.accountLockedPopupPrimaryCtaTitle}
            onClick={showFeatureLocked}
            className={`text-text16 font-semibold mt-10 py-2 px-4 focus:outline-none w-full ${
              featureFlaggingData?.sign_in?.forgot_password
                ? 'bg-red-600 text-white hover:bg-red-700'
                : 'bg-gray-300 text-white'
            }`}
          >
            {signInContentfulldata?.accountLockedPopupPrimaryCtaTitle}
          </button>
        )}

        <button
          aria-label={
            coorpUser
              ? signInContentfulldata?.signinIdentityVerification
                  ?.corp_user_cancel_button
              : signInContentfulldata?.accountLockedPopupSecondaryCtaTitle
          }
          onClick={onClose}
          className="text-text16 font-semibold mt-2 bg-white text-primary-red border border-primary-red py-2 px-4 hover:bg-red-50 focus:outline-none w-full"
        >
          {coorpUser
            ? signInContentfulldata?.signinIdentityVerification
                ?.corp_user_cancel_button
            : signInContentfulldata?.accountLockedPopupSecondaryCtaTitle}
        </button>

        <button
          onClick={onClose}
          className="absolute top-5 right-5"
          aria-label="Close modal"
        >
          <CloseIcon width="24" height="24" fill="#1F1F1F" />
        </button>
      </div>
    </div>
  );
};

export default LockedAccount;
